import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { makeStyles } from '@material-ui/core/styles';

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%'
}));

const DashboardLayoutWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: '64px',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '280px'
  },
	transition: theme.transitions.create(['padding', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    })
}));

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch'
});

const DashboardLayout = () => {
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);

	const useStyles = makeStyles((theme) => ({
		layoutWrapperOpen: {
		  paddingLeft: '280px !important'
		},
	}));

	const classes = useStyles();

  return (
    <>
			<DashboardLayoutRoot>
				<DashboardNavbar onMobileClose={() => setIsSidebarMobileOpen(false)} openMobile={isSidebarMobileOpen} className={isSidebarMobileOpen ? classes.layoutWrapperOpen : ""} onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)} />
				<DashboardSidebar
				onMobileClose={() => setIsSidebarMobileOpen(false)}
				openMobile={isSidebarMobileOpen}
				/>
				<DashboardLayoutWrapper className={isSidebarMobileOpen ? classes.layoutWrapperOpen : ""}>
					<DashboardLayoutContainer>
						<DashboardLayoutContent>
							<Outlet />
						</DashboardLayoutContent>
					</DashboardLayoutContainer>
				</DashboardLayoutWrapper>
			</DashboardLayoutRoot>
    </>
  );
};

export default DashboardLayout;
